class FornivoGallery extends HTMLElement {
  #ac; #viewer; #timer;
  connectedCallback() {
    this.#ac = new AbortController();
    const panels = [...this.querySelectorAll('[data-media-panel]')];
    const models = panels.filter(p => p.dataset.modelBrand);
    const photoFor = panel => panels.find(p => p.dataset.brand === panel?.dataset.modelBrand)?.querySelector('img');
    const template = models[0]?.querySelector('template');
    if (template) {
      this.#viewer = template.content.firstElementChild.cloneNode(true);
      this.#viewer.removeAttribute('src');
      this.#viewer.setAttribute('interaction-prompt','none');
      this.#viewer.setAttribute('shadow-intensity','0');
      this.#viewer.addEventListener('load', () => this.#viewer.dismissPoster?.(), {signal:this.#ac.signal});
    }
    const show = id => {
      clearTimeout(this.#timer);
      const panel = panels.find(p => p.dataset.mediaPanel === id);
      if (!panel) return;
      panels.forEach(p => p.hidden = p !== panel);
      this.querySelectorAll('[data-media-id]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mediaId === id)));
      if (!panel.dataset.modelBrand || !this.#viewer) {
        if (this.#viewer) this.#viewer.hidden = true;
        return;
      }
      const source = panel.querySelector('template').content.firstElementChild;
      const src = source.getAttribute('src');
      const photo = photoFor(panel);
      panel.append(this.#viewer);
      this.#viewer.hidden = false;
      this.#viewer.setAttribute('poster', photo?.currentSrc || photo?.src || '');
      this.#viewer.setAttribute('alt', source.getAttribute('alt'));
      if (this.#viewer.getAttribute('src') !== src) {
        this.#viewer.showPoster?.();
        this.#timer = setTimeout(() => {
          this.#viewer.setAttribute('camera-orbit','0deg 90deg auto');
          this.#viewer.setAttribute('src',src);
        }, 120);
      }
    };
    this.showMedia = show;
    this.addEventListener('touchmove', e => {
      if (e.composedPath().includes(this.#viewer)) e.preventDefault();
    }, {passive:false,signal:this.#ac.signal});
    this.addEventListener('command', e => {
      if(e.command === '--show-image') show(e.source?.dataset.mediaId);
    }, {signal:this.#ac.signal});
    const active = panels.find(p => !p.hidden);
    if(active) show(active.dataset.mediaPanel);
    if(this.#viewer && !customElements.get('model-viewer')) import('https://ajax.googleapis.com/ajax/libs/model-viewer/4.4.0/model-viewer.min.js').then(() => {
      const Viewer = customElements.get('model-viewer');
      if(Viewer) Viewer.modelCacheSize = 0;
    }).catch(() => {
      const active = panels.find(p => !p.hidden);
      const photo = panels.find(p => p.dataset.brand === active?.dataset.modelBrand);
      if(photo) show(photo.dataset.mediaPanel);
    });
  }
  disconnectedCallback() { clearTimeout(this.#timer); this.#ac?.abort(); this.#viewer?.removeAttribute('src'); this.#viewer?.remove(); }
}
if(!customElements.get('fornivo-gallery')) customElements.define('fornivo-gallery',FornivoGallery);